import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WindowBox from '../../../../components/WindowBox';
import { reduxForm } from 'redux-form';
import './style.css';
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl';
const messages = defineMessages({
  selectPic: {
    id: 'id',
    defaultMessage: '請選擇個人大頭照',
  },
  fileSizeLimit: {
    id: 'SH_FileSizeLimit',
    defaultMessage: '大小限制為 {0}',
  },
});
export class UploadPersonalImgForm extends Component {
  constructor(props) {
    super(props);
    this.onFileChange = this.onFileChange.bind(this);
  }

  onFileChange(event) {
    event.preventDefault();
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    this.props.fields.picture.onChange(event.target.files[0]);
    this.props.fields.forceUpdate.onChange(event.target.files[0].name);
  }


  renderUploadForm() {
    const picture = this.props.fields.picture;

    return (
      <WindowBox width={340} title={[<FormattedMessage key="1" id="FD_ChangePhoto" defaultMessage="更改個人大頭照" />]} onClose={this.props.onClose}>
        <div className="personal-img-uploader-form">
          <form className="upload-form" onSubmit={this.props.handleSubmit}>
            <div className="input-group">
              <div className="form-control" title={ picture.value && picture.value.name }>
                { picture.value && picture.value.name }
              </div>
              <label className="input-group-addon btn" htmlFor="uploader">
                <FormattedMessage id="SH_SelectFile" defaultMessage="選擇檔案" />
              </label>
            </div>
            <input type="file" className="form-control" id="uploader" accept="image/*" max="300"
              onChange={this.onFileChange}
            />
            {
              picture.dirty && picture.error &&
                <span
                  className="text-danger"
                  style={{
                    margin: 15,
                  }}
                >
                  { picture.error }
                </span>
            }
            <ul className="notifications basic__helpBlock">
              <li><FormattedMessage id="SH_PicFileLimit" defaultMessage="檔案格式限制為 JPG, JPEG, GIF, PNG" /></li>
              <li>
                <FormattedMessage
                  id="SH_FileSizeLimit"
                  defaultMessage="大小限制為 {0}"
                  values={{
                    0: '300KB',
                  }}
                />
              </li>
            </ul>
            <hr />
            <div className="action-group clearfix">
              <button className="btn btn-default" onClick={this.props.onClose}>
                <FormattedMessage id="SH_Cancel" defaultMessage="取消" />
              </button>
              <button className="btn btn-primary" disabled={picture.invalid}>
                <FormattedMessage id="SH_Confirm" defaultMessage="確定" />
              </button>
            </div>
          </form>
        </div>
      </WindowBox>
    );
  }


  render() {
    if (!this.props.submitting) {
      return this.renderUploadForm();
    }
    return (
      <div className="personal-img-uploader-form loading-container" >
        <span className="fa fa-spinner fa-spin fa-3x loading">
        </span>
      </div>
    );
  }
}

UploadPersonalImgForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};


/*
  替換要上傳檔案的時候，Props不會更新，
  導致畫面不會顯示新的檔案名稱，
  但是如果去更動其他欄位時，會連動更新Props,
  所以建了個假欄位forceUpdate，讓檔案上傳的時候會更新，
  有空再回來查是什麼原因 Orz
 */

export const fields = [
  'picture',
  'forceUpdate',
];

export const formName = 'foundation/mydata/UploadPersonalImgForm';

const validate = (values, props) => {
  const errors = {};
  if (!values.picture) {
    errors.picture = props.intl.formatMessage(messages.selectPic);
  }
  if (values.picture && values.picture.size > 300000) {
    errors.picture = props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' });
  }
  return errors;
};

UploadPersonalImgForm = reduxForm({
  form: 'foundation/mydata/UploadPersonalImgForm',
  fields,
  validate,
})(UploadPersonalImgForm);

export default injectIntl(UploadPersonalImgForm);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/components/UploadPersonalImgForm/index.js
 **/